import React from 'react';

const techs = ['REACT', 'NEXT.JS', 'NODE.JS', 'FLUTTER', 'SHOPIFY', 'WORDPRESS', 'FIGMA', 'AWS'];

const Marquee = () => {
  const items = [...techs, ...techs].flatMap((t) => [t, '—']);

  return (
    <div className="marquee-section">
      <div className="marquee">
        {items.map((item, i) => (
          <span className="marquee__item" key={i}>{item}</span>
        ))}
        {items.map((item, i) => (
          <span className="marquee__item" key={`dup-${i}`}>{item}</span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
